export const SET_CONTEXT = 'SET_CONTEXT';
export const setContext = (payload) => ({type: SET_CONTEXT, payload});

export const initContext = ({history}) => {
    return (dispatch, getStage) => {
        let token = sessionStorage.getItem('token');
        if(token) {
            dispatch(setContext({
                token: token
            }));
        } else {
            // history.push('/login');
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/context.js